/** Build-time trust anchor. Never infer the artwork host from an API response. */
export function trustedArtworkBaseUrl(): string | null {
  const value: unknown = import.meta.env.VITE_NFT_ARTWORK_PUBLIC_BASE_URL;
  return typeof value === "string" && validArtworkBaseUrl(value) ? value : null;
}

export function validArtworkBaseUrl(value: string): boolean {
  try {
    const url = new URL(value);
    // Exact serialization also rejects whitespace, dot segments and explicit default ports.
    return url.protocol === "https:" && !url.username && !url.password && !url.search && !url.hash &&
      url.pathname.endsWith("/nft-artwork") && url.href === value && !/%|\\/.test(value);
  } catch { return false; }
}
